import { axios } from "../axios.instance";

export type InviteUsersRequest = {
  phoneNumbers: string[];
};

export type InviteUsersResponse = object;

export const inviteUsers = async (body: InviteUsersRequest): Promise<InviteUsersResponse> => {
  const { data } = await axios.post(`/invites/invite-multiple`, body);

  return data;
};
